<template>
    <Button
        :interfaceTarget="`${props.id}-sign-in-button`"
        :color="props.color"
        :size="props.size"
        width="full"
        :disabled="props.disabled"
        :class="props.size === 's' && $style.small_button_override"
        @click="props.onClick"
    >
        <Icon :name="props.id" />
        <Typography
            type="label"
            :responsive="false"
            :size="props.size === 's' ? 's' : 'm'"
            accent
        >
            {{ label }}
        </Typography>
    </Button>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import Button from '@/components/Buttons/Button.vue'
import Icon from '@/components/Icon/Icon.vue'
import Typography from '@/components/Typography.vue'
import { useTr } from '@/composables/use-tr'

const props = defineProps<{
    color: 'carbon-400' | 'carbon-200'
    size: 's' | 'l'
    id: 'apple' | 'microsoft' | 'google'
    providerDisplayName: string
    disabled: boolean
    onClick: (e: MouseEvent) => void
}>()

const tr = useTr()

const label = computed(() =>
    props.size === 's'
        ? props.providerDisplayName
        : tr('socialLogins.sign_in_with', {
              providerName: props.providerDisplayName,
          }),
)
</script>

<style module>
.small_button_override {
    height: 36px;
    width: 120px;
}
</style>
